<template>

  <div id="HearingSpeechTest">
    <HearingSteps current-step="Speech_test" :dot-count="0" :currentDot="0"></HearingSteps>
    <div id="speechTest">
      <div class="info-help" v-show="!startedTest">
        <div class="HearingTest-test--part speech-section">
          <div class="HearingTest-test--title">تست گفتاری</div>
          <div class="HearingTest-test--text">این تست از شما میخواهد کلمه ای که میشنوید را انتخاب کنید، همچنین به تعیین چگونگی شنیدن و تشخیص گفتار در سطح شنوایی نرمال به شما کمک خواهد کرد. </div>
          <button class="HearingTest-test--button begin-test-btn testBtn" v-show="!loaded" ><icon name="spinner" pulse></icon></button>
          <button class="HearingTest-test--button begin-test-btn testBtn" v-show="loaded" @click="startTest();" ><span>شروع تست</span> &gt;</button>
        </div>
        <div class="clearfix"></div>

      </div>
      <div class="clearfix"></div>
      <div class="HearingTest-test--part speech-section"  v-if="curSpeech !== null" v-show="startedTest">
        <div class="HearingTest-test--title">کدام را می شنوید؟</div>
        <div class="HearingTest-test--text">لطفا کلمه ای که می شنوید را انتخاب کنید.</div>
        <v-container fluid grid-list-md>
        <v-layout row wrap >
          <v-flex v-for="(word, key) in curSpeech.words"  :key="word.id" sm3 xs6 >
            <div class="HearingTest-test--button" @click="nextQuestion(word)">{{ word }}</div>
          </v-flex>
        </v-layout>
        </v-container>

        <div class="HearingTest-test--textButton ng-binding" @click="playSpeechSound();">
          <icon name="repeat"></icon> پخش مجدد کلمه
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import HearingSteps from './steps.vue';
  import Icon from "../../../node_modules/vue-awesome/components/Icon.vue";
export default {
    name: 'HearingCalibration',

    components: {
        Icon,
        HearingSteps,
    },
  mounted() {
      // check user passed prev steps, if not go home!
      if(!window.questionsAnswer || !window.calibrationAnswers || !window.PureToneAnswers)
          this.$parent.$router.replace('/');
      this.init();
  },
  data () {

    return {
        loaded: false,
        startedTest: false,
        speeches:{},
        curSpeech: null,
        curSpeechCounter:0,
        curAudio: null,
        answers : [],
    }
  },
    watch: {

    },
    methods:{
        init(){
            let self = this;
            self.axios.get(ApibaseUrl+"api/v1/hearing_speech_words").then((response) => {
                self.speeches = response.data.result;
                self.speeches.forEach(function(value, key) {
                    value.audio = new Audio(value.audio);
                });

                this.showQuestion();

                self.loaded = true;
            });
            //"audio": new Audio('http://localhost:8000/media/sounds/speechs/01shir.mp3')

        },
        startTest(){
            this.startedTest = true;
            this.playSpeechSound();
        },
        showQuestion(){

            this.curSpeech = this.speeches[this.curSpeechCounter];

            this.curAudio = this.curSpeech.audio;

            let volume = 1;
            if(window.calibrationAnswers.type === 'headphone'){
                volume = ((window.calibrationAnswers.data.leftFirst + window.calibrationAnswers.data.rightFirst)/ 2) / 100;
            }else {
                volume = window.calibrationAnswers.data.first / 100;
            }

            this.curAudio.volume = volume;

        },
        playSpeechSound(){
            this.curAudio.play();
        },
        nextQuestion(word){

            this.curAudio.pause();
            this.currentTime = 0;
            this.answers[this.curSpeech.id] = {
                'answer': this.curSpeech.answer === word ? 1 : 0,
                'answerText': this.curSpeech.answer,
            };

            if(this.curSpeechCounter < this.speeches.length-1) {

                this.curSpeechCounter++;
                this.showQuestion();
                this.playSpeechSound();
            }else{
                this.doneTest();
            }
        },
        doneTest(){
            window.SpeechTestAnswers = this.answers;
            console.log("all is done!",this.answers);
            this.$parent.$router.replace('/show_result');
        }
    }
}
</script>

<style scoped>
  #speechTest{
    margin: 40px 0;
    text-align: center;
    padding: 0 10px 30px;
  }
  #speechTest button{
    display: block;
    text-align: center;
    cursor: pointer;
    border: none;
    width: 34%;
    margin: 0 auto;
    padding-top: 12px;
    padding-bottom: 10px;
    background-color: #00b7c6;
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 20px;
    color: #fff;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
  }@media (max-width: 599px) {
    #speechTest button{
      width: 90%;
    }
  }
  .HearingTest-test--title {
    text-align: center;
    margin-bottom: 10px;
    font-weight: normal;
    font-style: normal;
    font-size: 54px;
    line-height: 52px;
    color: #00b7c6;
  }
  .HearingTest-test--text {
    text-align: center;
    margin-bottom: 20px;
    font-weight: normal;
    font-style: normal;
    font-size: 16px;
    line-height: 22px;
    color: #000;
  }
  .HearingTest-test--textBold {
    text-align: center;
    margin: 0 90px 30px;
    font-weight: normal;
    font-style: normal;
    font-size: 19px;
    line-height: 22px;
    color: #000;
  }
  .HearingTest-test--part .HearingTest-test--button {
    display: block;
    text-align: center;
    cursor: pointer;
    border: none;
    padding-top: 12px;
    padding-bottom: 10px;
    background-color: #00b7c6;
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 20px;
    color: #fff;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    margin-bottom: 10px;
  }
 .HearingTest-test--part .HearingTest-test--textButton {
   width: 100%;
   text-align: center;
    display: inline-block;
    margin: 24px auto 0;
    font-weight: normal;
    font-style: normal;
    font-size: 30px;
    line-height: 30px;
    color: #00b7c6;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/HearingTest/HearingSpeechTest.vue